/**
 *
 *
 * This component render the menue on the navigation bar
 *  according to the divice the the header changes
 * message and formated message is used for localisation
 *
 * myAccount is the component used for login and when the
 * user login the view change to user profile dropdown
 * which show prescription healthrecord and appointments
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Update Ant Design Icon import as per React 18 and Ant Design's latest recommendations
// import { FormattedMessage } from 'react-intl';
import { Menu } from 'antd';
import { LoginOutlined } from '@ant-design/icons'; // Ant Design Icons
import MyAccount from '../MyAccount/Index';
import { BodyTextValue } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const MenuMarkup = ({ mobileVersion, activeLinkKey, onLinkClick, className }) => {

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;    
    
    return (
        <div>
            <div>
                <Menu
                    theme="light"
                    mode={mobileVersion ? 'vertical' : 'horizontal'}
                    selectedKeys={[`${activeLinkKey}`]}
                    style={{ lineHeight: '62px', display: 'flex', justifyContent: 'flex-end' }}
                    className={className}
                >
                    <Menu.Item key="1">
                        {sessionStorage.getItem('jwt') !== null ? (
                            <MyAccount />
                        ) : (
                            <Link onClick={onLinkClick} to="/login">
                                <LoginOutlined /> {/* Updated icon */}
                                {/* <FormattedMessage {...messages.HeaderLogIn} /> */}
                                <BodyTextValue text={`${langdata.HeaderLogIn ? langdata.HeaderLogIn : 'Login' }`} />
                            </Link>
                        )}
                    </Menu.Item>
                </Menu>
            </div>
        </div>
    );
};

MenuMarkup.propTypes = {
    mobileVersion: PropTypes.bool,
    activeLinkKey: PropTypes.string.isRequired,
    onLinkClick: PropTypes.func,
    className: PropTypes.string,
};

MenuMarkup.defaultProps = {
    mobileVersion: false,
    className: 'mobile-navigation',
};

export default MenuMarkup;

